"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertArrayToLngLat = convertArrayToLngLat;
function convertArrayToLngLat(coords) {
    return {
        latitude: coords[1],
        longitude: coords[0],
    };
}
//# sourceMappingURL=convertArrayToLngLat.js.map